import React, { useState, useImperativeHandle } from 'react';
import omit from 'lodash-es/omit';
import { ConfirmDialog } from './ConfirmDialog';
import { GlobalThemeProvider } from '../../ThemeProvider';
export const InternalConfirm = (fullProps) => {
    const { handlerRef, withGlobalThemeProvider, ...props } = fullProps;
    const [open, setOpen] = useState(true);
    const [options, setOptions] = useState(props);
    useImperativeHandle(handlerRef, () => {
        const handler = {
            close: () => {
                setOpen(false);
            },
            open: () => {
                setOpen(true);
            },
            update: (newOptions) => {
                setOptions({ ...options, ...newOptions });
            },
        };
        return handler;
    });
    const opts = omit(options, [
        'open',
        'onOk',
        'onCancel',
        'onBackdropClick',
        'onEscapeKeyDown',
        'escapeKeyDownClosable',
        'backdropClickClosable',
    ]);
    function handleCallback(callback) {
        const func = (e, supplementaryEvent) => {
            // eslint-disable-next-line n/no-callback-literal
            const result = callback?.(e, supplementaryEvent);
            if (result &&
                Object.prototype.toString.call(result) === '[object Promise]') {
                return new Promise((resolve, reject) => {
                    result
                        .then(() => {
                        setOpen(false);
                        resolve();
                    })
                        .catch((err) => {
                        reject(err);
                    });
                });
            }
            setOpen(false);
        };
        return func;
    }
    const dialog = (React.createElement(ConfirmDialog, { ...opts, open: open, onOk: handleCallback(options?.onOk), onCancel: handleCallback(options?.onCancel), onBackdropClick: (e) => {
            if (options.backdropClickClosable) {
                void options?.onCancel?.(e, { type: 'backdropClick' });
                setOpen(false);
            }
        }, onEscapeKeyDown: (e) => {
            if (options.escapeKeyDownClosable) {
                void options?.onCancel?.(e, { type: 'escapeKeyDown' });
                setOpen(false);
            }
        } }));
    if (withGlobalThemeProvider) {
        return React.createElement(GlobalThemeProvider, null, dialog);
    }
    return dialog;
};
